import { BadgeClass } from './css-badge-classes';
import { ScanRegionStatus } from './enums';

export const ScanRegionStatusClassMapping: Map<ScanRegionStatus, BadgeClass> = new Map([
    [ScanRegionStatus.ActionNeeded, BadgeClass.None],
    [ScanRegionStatus.Approved, BadgeClass.Approved],
    [ScanRegionStatus.Cancelled, BadgeClass.None],
    [ScanRegionStatus.Completed, BadgeClass.None],
    [ScanRegionStatus.Declined, BadgeClass.Declined],
    [ScanRegionStatus.OrderPending, BadgeClass.None],
    [ScanRegionStatus.Requested, BadgeClass.None]
]);
